import zhLocale from 'element-ui/lib/locale/lang/zh-CN' //引入element语言包
const cn = {
  posterPage: {
    title1:'订阅功能即将上线！',
    title2:'订阅续费，特权升级！',
    title3:'专属折扣，续费更划算',
    title4:'获取兑换码，您可以咨询购买设备的销售商家',
    title5:'优先体验功能',
    function1:'功能详情：',
    function2:'基础服务续费（同传翻译、会议助理、智能助手）..',
    function3:'增值服务订阅（离线翻译、音视频通话翻译）..',
  },
  RedemptionCodePage: {
    RedemptionCode: '兑换码',
    ValueAddedServices: '增值服务',
    UpgradedExperience: '专属增值权益，体验升级',
    OfflineTranslation: '离线翻译',
    NoInternet: '无需联网 · 即时翻译 · 安全可靠',
    GoToSubscribe: '去订阅',
    AudioAndVideoCall: '音/视频通话',
    RealTimeCall: '实时语音转译·沟通无障碍',
    BaseService: '基础服务',
    AIAssistant: '功能：同传翻译·会议助理·AI助手',
    LanguagesSetting:'语言设置',
    languages1:'简体中文',
    languages2:'繁体中文',
    languages3:'英文',
    languages4:'日语',
    languages5:'韩语',
    languages6:'俄语',
    languages7:'西班牙语',
    languages8:'法语',
    languages9:'德语',
    languages10:'葡萄牙语',
    languages11:'意大利语',
    languages12:'土耳其语',
    languages13:'越南语',
    languages14:'印尼语',
    languages15:'印地语',
    languages16:'阿拉伯语',
    languages17:'泰语',
    languages18:'波斯语',
  },
  Login: {
    ToLogin: '登录',
    PhoneLogin: '手机号登录',
    EmailLogin: '邮箱登录',
    PhonePlaceholder: '请输入手机号',
    EmailPlaceholder: 'Enter email',
    Code: '验证码',
    and: '和',
    BeforeText: '创建账户的同时代表你同意并遵守',
    UserAgreement: '用户协议',
    privacy: '隐私政策',
    errorMessage: '验证码错误',
    readTitle: '阅读并同意以下协议',
    readBefore: '为保证您的个人信息安全，请先阅读并同意',
    cancel: '取消',
    agree: '同意并继续',
    error1:'请输入有效的邮箱地址',
    error2:'请输入正确的手机号',
    error3:'请输入验证码',
    success:'登录成功'
  },
  OffLinePage: {
    title: '离线翻译',
    NoInternet: '无需联网 · 即时翻译 · 安全可靠',
    ServiceLife: '使用期限',
    forever: '永久使用',
    describe: '订阅说明',
    describeItem1: '1.离线翻译功能为一次性付费，永久使用，使用权限跟随蓝牙设备，如果更换设备，需重新订阅离线翻译兑换码。',
    describeItem2: '2.授权码订阅后不可退费。',
    describeItem3: '3.支持10种语言：中文、英语、德语、日语、韩语、印地语、 泰语、西班牙语、法语、俄语。',
    quantity: '数量',
    payType: '支付方式',
    card: '银行卡',
    wx: '微信',
    GooglePay: 'Google Pay',
    subscribe: '订阅',
    RMB: '¥',
    confirm:'确认',
    cardNumber:'卡号',
    periodOfValidity:'有效期',
    safetyCode:'安全码',
    name:'姓名',
    yearAndMonth:'年份/月份',
    message1:'数量不能为0',
    popTip:'温馨提示',
    popText1:'请您仔细阅读并理解',
    popText2:'离线翻译付费协议',
    popText3:'我已阅读并同意',
    popText4:'已阅读并同意',
  },
  AudioVideoPage: {
    title: '音/视频通话',
    RealTime: '实时语音转译·沟通无障碍',
    describe: '订阅说明',
    describeItem1: '1.音视频通话翻译功能为充值购买分钟数，分钟数从接通通话开始计算时长，权限跟随账号，如果登录其它账号，需重新充值。',
    describeItem2: '2.账号充值后连接和绑定不同设备能照常使用。',
    describeItem3: '3.音视频通话翻译功能充值后不可退费。',
    payType: '支付方式',
    card: '银行卡',
    wx: '微信',
    GooglePay: 'Google Pay',
    subscribe: '订阅',
    RMB: '¥',
    sale: '折扣',
    confirm:'确认',
    time1:'秒',
    time2:'分钟',
    time3:'小时',
    time4:'天',
    time5:'月',
    time6:'年',
  },
  OffLineResult: {
    title1: '离线翻译',
    title2: '音/视频通话',
    title3: '基础服务',
    success: '订阅成功',
    fail:'订阅失败',
    stock:'兑换码备货中...',
    saveTitle: '保存兑换码，前往APP进行兑换使用',
    code: '兑换码',
    tip1: '此码仅用于兑换离线翻译功能',
    tip2: '此码仅用于兑换音/视频通话翻译功能',
    tip3: '此码仅用于兑换基础服务续费功能',
    save: '保存',
    time: '订阅时间：',
    copy: '复制',
    copySuccess: '复制成功',
    loading:'加载中...',
    paySuccess:'支付成功'
  },
  RedemptionList: {
    title: '我的兑换码',
    view: '查看',
    time: '订阅时间：',
  },
  MyRedemption: {
    title: '我的兑换码',
    code: '兑换码',
    time: '订阅时间：',
    copy: '复制',
    tip1: '此码仅用于兑换离线翻译功能',
    tip2: '此码仅用于兑换音/视频通话翻译功能',
    tip3: '此码仅用于兑换基础服务续费功能',
    save: '保存',
    success:"操作成功"
  },
  basePage:{
    error1:'没有获取到商品信息',
    message1:'请选择商品',
    title:'基础服务',
    function:'功能：同传翻译·会议助理·AI助手',
    describe: '订阅说明',
    describe1:'1.同传翻译、会议助理等基础服务续费之后，有效期跟随设备，如果更换设备，需重新续费。',
    describe2:'2.基础服务续费后不可退费。',
    payType: '支付方式',
    card: '银行卡',
    wx: '微信',
    GooglePay: 'Google Pay',
    subscribe: '订阅',
    RMB: '¥',
    sale: '折扣',
    month:'月',
    confirm:'确认',
    month1:'1个月',
    month2:'半年',
    month3:'1年'
  },
  ...zhLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default cn;
